/*
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-07 12:00:03
 * @LastEditTime: 2021-05-14 16:09:38
 * @LastEditors: JDY
 */
import { asyncRouterMap } from '@/config/router.config'
function filterRouter (routerMap) {
    const accessedRouters = routerMap.filter(route => {
        if (route.meta?.permission) {
            if (route.children && route.children.length) {
                route.children = filterRouter(route.children)
            }
            return true
        }
        return false
    })
    return accessedRouters
}

function filterActionData (route) {
    const { action } = route
    const keys = Object.keys(action)
    const newAction = keys.map(item => {
        return {
            title: action[item],
            key: route.permission[0] + '-' + item,
            value: route.permission[0] + '-' + item
        }
    })
    return newAction
}

function filterPermissionData (routerMap) {
    const permission = routerMap.map(route => {
        if (route.children?.length) {
            route.children = filterPermissionData(route.children)
            return {
                title: route.meta.title,
                key: route.meta.permission[0],
                value: route.meta.permission[0],
                children: route.children
            }
        }
        if (route.meta?.action) {
            return {
                title: route.meta.title,
                key: route.meta.permission[0],
                value: route.meta.permission[0],
                children: filterActionData(route.meta)
            }
        }
        return { title: route.meta.title, key: route.meta.permission[0], value: route.meta.permission[0] }
    })
    return permission
}
const RouteData = JSON.parse(JSON.stringify(asyncRouterMap[0]))
const newRouteData = filterRouter(RouteData.children)
const permissionData = filterPermissionData(newRouteData)
export default permissionData
